// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authReducer';
import { userCreateReducer } from './reducers/userReducer';
import ruleReducer from './reducers/ruleReducer';
import { subscriptionReducer } from './reducers/subscriptionReducer';
import bundleReducer from './reducers/bundleReducer';
import teamReducer from "./reducers/teamReducer"
import userTeamReducer from './reducers/userTeamReducer'
import getUserListReducer from './reducers/getUserListReducer'
import userMainReducer from './reducers/userMainReducer';
import gameRulesReducer from './reducers/gameRulesReducer';
import ruleDetailsReducer from './reducers/ruleDetailsReducer';
import clockStatsOnlyReducer from './reducers/clockStatsOnlyReducer';
// import userSubReducer from './reducers/userSubReducer';


const store = configureStore({
  reducer: {
    auth: authReducer,
    userCreate: userCreateReducer,
    rule: ruleReducer,
    subscription: subscriptionReducer,
    bundle: bundleReducer, 
    team: teamReducer,
    userTeam: userTeamReducer,
    userList: getUserListReducer,
    user: userMainReducer,
    // userSub: userSubReducer,
    gameRules: gameRulesReducer,
    ruleDetails: ruleDetailsReducer,
    clockStatsOnlyReducer: clockStatsOnlyReducer,

  },
});

export default store;
